import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TPostSegmentLogo, TSegmentLogo } from '../types';

export async function postSegmentLogo(body: TPostSegmentLogo): Promise<TSegmentLogo> {
  return mediaManagerClient
    .post('/api/v1/segment_logos', emptyStringValues(body))
    .then(response => response as unknown as TSegmentLogo);
}

type MutationFn = typeof postSegmentLogo;

type TUsePostSegmentLogoParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePostSegmentLogo({ config }: TUsePostSegmentLogoParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: postSegmentLogo,
    onError(error) {
      addErrorNotification(t('No se ha podido crear el logo del segmento'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El logo del segmento se ha creado correctamente'));
    },
  });
}
